import { render, staticRenderFns } from "./uyeEkle.vue?vue&type=template&id=c39bd06a&scoped=true"
import script from "./uyeEkle.vue?vue&type=script&lang=js"
export * from "./uyeEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39bd06a",
  null
  
)

export default component.exports